/**
 *
 * Asynchronously loads the component for Register
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
